<div class="page-wrapper p-3">
  <div class="container-fluid">
    <form role="form" class="form-horizontal">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 mt-2">
          <div
            *ngFor="let list of selectedUniversityList; let i = index"
            class="fform-group mt-4 row border-bottom pt-2 pb-3"
          >
            <div [ngClass]="{ 'col-sm-5 col-row-main': true }">
              <div class="ml-2">
                <h4 class="col-nm d-flex align-items-center mb-0">
                  <img
                    *ngIf="list?.imageAvailable"
                    [src]="list?.collegeProfileIcon"
                  />
                  <!-- [ngClass]="AddHypen ? 'addhypen' : ''" -->
                  <span
                    *ngIf="list?.imageAvailable == false"
                    id="randomcolor"
                    [style.backgroundColor]="list.defaultLabelColor"
                  >
                    {{ getFirstAndLastWords(list.name) }}
                  </span>
                  <!-- <img
                    [ngClass]="checkIconStatus(list?.collegeProfileIcon)"
                    [src]="list?.collegeProfileIcon"
                  /> -->
                  <!-- <img
                      src="https://cdn.virtueanalytics.com/cache/college-icon-top5.png"
                    /> -->
                  <span> {{ list.name }} ({{ list.stateCode }})</span>
                </h4>
                <div class="acc-rate">
                  <!-- <span >Acceptance Rate <strong>{{getAcceptanceRate1(list?.ipedsId,i)}} %</strong> -->
                  <span *ngIf="getAcceptanceRate1(list?.ipedsId, i)"
                    >Acceptance Rate
                    <strong>{{ getAcceptanceRate1(list?.ipedsId, i) }}%</strong>
                    <span
                      *ngIf="list.control && list.control != 'null'"
                      class="pl-2 pr-2 text-secondary"
                      >|</span
                    >
                  </span>
                  <span *ngIf="list.control && list.control != 'null'">
                    {{ getControlType(list.control) }}

                    <span
                      class="pl-2 pr-2 text-secondary"
                      *ngIf="list.hbcuCollege"
                      >|</span
                    >
                  </span>
                  <span *ngIf="list.hbcuCollege"> HBCU
                    
                   
                  </span>
                  <span *ngIf="list?.collegeRankInUS">
                    
                    <span
                    class="pl-2 pr-2 text-secondary"
                    
                    >|</span
                  >
                    Rank: <strong>{{list?.collegeRankInUS}} </strong></span>
                </div>
              </div>
            </div>

            <div class="col-sm-4 text-center m-last">
              <div class="awrdletter-tog">
                <div class="let">
                  <button
                    type="button"
                    class="custom-button"
                    *ngIf="showuploadButton[i]"
                  >
                    <!-- <fieldset disabled="disabled">
                      <span
                        *ngIf="
                          ocrResponseListTotal[i] == undefined ||
                          ocrResponseListTotal[i].analylizedFiles.length == 0
                        "
                        ><img
                          src="https://cdn.virtueanalytics.com/cache/award-letter-icon-top5.png"
                      /></span>
                    </fieldset>
                    <span
                      *ngIf="
                        ocrResponseListTotal[i] != undefined &&
                        ocrResponseListTotal[i].analylizedFiles.length > 0
                      "
                    >
                      <a
                        tooltip="View Award Letter"
                        (click)="
                          openAwardLetter(
                            ocrResponseListTotal[i]?.analylizedFiles
                          )
                        "
                      >
                        <img src="assets/images/uploaded3.png" />
                      </a>
                    </span> -->

                    <fieldset disabled="disabled">
                      <span
                        *ngIf="
                          viewImgPdfArray[i] == undefined ||
                          viewImgPdfArray[i].length == 0
                        "
                        ><img
                          src="https://cdn.virtueanalytics.com/cache/award-letter-icon-top5.png"
                      /></span>
                    </fieldset>

                    <span *ngIf="viewImgPdfArray[i] != undefined">
                      <a
                        tooltip="View Award Letter"
                        (click)="openAwardLetter(viewImgPdfArray[i])"
                      >
                        <img src="assets/images/uploaded3.png" />
                      </a>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-3 oncamp">
              <div *ngIf="showuploadButton[i]" class="disabled">
                <fieldset disabled="disabled">
                  <app-residency-selction-options
                    [pageAnswer]="interestPageAnswerMap"
                    [options]="getCampusOption(i)"
                    [index]="'r' + i"
                    [placeholder]="'Select Campus'"
                  >
                  </app-residency-selction-options>
                </fieldset>
              </div>
              <!-- <div *ngIf="showuploadButton[i]" class="reset-in-row">

                </div> -->
            </div>
            <div class="col-12 optionp">
              <div
                class="row affiinity-row mb-1 mt-5"
                *ngFor="
                  let ans of yearWiseAffinityQuestion[i];
                  let index = index
                "
              >
                <div class="head col-md-12">Affinity Questions</div>
                <div class="col-md-12 optionp">
                  <div class="row">
                    <div class="col-md-6 mb-2 mt-2">
                      <label
                        for="questions"
                        class="col-sm-12 control-label font-normal text-dark"
                        ><span>{{ ans.label }}</span></label
                      >
                      <div class="col-sm-6 in-option mt-1 ml-4">
                        <fieldset disabled="disabled">
                          <!-- <div class="form-check-inline"> -->
                          <app-checkboxoption
                            [pageAnswer]="interestPageAnswerMap"
                            [index]="'aq' + i + '-' + index"
                            [name]="i + '-' + index"
                            [options]="ans.options"
                            [Affinityindex]="index"
                            [Universityindex]="i"
                          >
                          </app-checkboxoption>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- </tui-loader> -->
        </div>
      </div>
    </form>
  </div>
</div>

<div class="align-page-bottom">
  <div class="text-center border-top pt-4">
    <button class="page-btn" (click)="next()">Next</button>
  </div>
</div>
